import type { EntityDetailMetadata } from '@zag/ui';

export const CALENDAR_ENTITY_DETAIL_METADATA = [
  {
    entity: 'calendar-settings',
    route: '/calendars-list/:id',
    titleKey: 'calendars.title',
    sections: [
      { id: 'details', titleKey: 'calendars.settings.sections.details' },
      { id: 'work-locations', titleKey: 'calendars.settings.workLocation.title', requiresEntityId: true },
    ],
    actions: [
      {
        id: 'save',
        labelKey: 'common.save',
        visibleWhen: { mode: 'any', permissions: ['calendars:create', 'calendars:update'] },
        intent: 'mutation',
      },
      {
        id: 'sync-holidays',
        labelKey: 'calendars.settings.quickActions.syncHolidays',
        visibleWhen: { mode: 'all', permissions: ['calendars:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['calendars:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'slot-type',
    route: '/settings/slot-type-definitions/:id',
    titleKey: 'settings.slotTypes.title',
    sections: [{ id: 'details', titleKey: 'settings.slotTypes.sections.details' }],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['settings:update'] }, intent: 'mutation' },
      {
        id: 'activate',
        labelKey: 'common.activate',
        visibleWhen: { mode: 'all', permissions: ['settings:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
      {
        id: 'deactivate',
        labelKey: 'common.deactivate',
        visibleWhen: { mode: 'all', permissions: ['settings:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['settings:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
